import { render } from "./chexiaoPayAccounts.vue?vue&type=template&id=6d1106c7"
import script from "./chexiaoPayAccounts.vue?vue&type=script&lang=js"
export * from "./chexiaoPayAccounts.vue?vue&type=script&lang=js"

import "./chexiaoPayAccounts.vue?vue&type=style&index=0&id=6d1106c7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__